// context/UserContext.js
import { createContext, useState, useEffect } from "react";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({
    username: localStorage.getItem("userName"),
    firstName: localStorage.getItem("first_name"),
    lastName: localStorage.getItem("last_name"),
    profile_image: localStorage.getItem("profile_image"),
    email: localStorage.getItem("email"),
  });

  const updateUser = (newUser) => {
    setUser(newUser);
  };
  return (
    <UserContext.Provider value={{ datauser: user, updateUser }}>
      {children}
    </UserContext.Provider>
  );
};
